// extracted by mini-css-extract-plugin
module.exports = {"tab":"style_tab__1JKbX","active":"style_active__ugHys","header":"style_header__q0Xg6","button":"style_button__2Q5NL","buttonActive":"style_buttonActive__3ccvn"};